var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDimensions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1605_149059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9555 18.3196V18.2423L33.8863 18.2078L25.6683 14.1069L25.6125 14.0791L25.5567 14.1069L13.4339 20.1561L13.3647 20.1907V20.268V28.5663V28.6436L13.4339 28.6781L21.6522 32.7793L21.7081 32.8071L21.7639 32.7793L33.8863 26.7297L33.9555 26.6952V26.6179V18.3196ZM23.1665 24.2857L32.887 19.4351V26.0358L22.2421 31.3479V24.7468L23.1665 24.2857L23.1665 24.2857ZM21.1737 31.3479L14.4332 27.9841V21.3834L21.1737 24.7468V31.3479ZM25.6125 15.2715L32.2263 18.572L21.7081 23.8209L15.0939 20.5204L25.6125 15.2715Z",
    fill: "#6d4096",
    stroke: "#6d4096",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1124 20.805V28.02H8.8584V28.5988H11.946V28.02H10.692V20.805H11.946V20.2266H8.8584V20.805H10.1124Z",
    fill: "#6d4096"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9454 13.3336L36.1061 16.9068L35.2438 17.3373L35.5033 17.8548L38.2648 16.4767L38.0057 15.9592L36.7543 16.5834L29.5937 13.0101L30.4559 12.58L30.1965 12.0625L27.4349 13.4405L27.694 13.958L28.9454 13.3336Z",
    fill: "#6d4096"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1039 28.0261L25.0388 33.5477L23.7874 32.9232L23.5283 33.4411L26.2899 34.8191L26.5493 34.3016L25.687 33.8712L36.7522 28.3495L38.0036 28.974L38.2627 28.4562L35.5011 27.0781L35.2417 27.5956L36.1039 28.0261Z",
    fill: "#6d4096"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1605_149059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 30,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensions);
export default __webpack_public_path__ + "static/media/dimensions.d3a9a580239b7a762fbcd0642831da08.svg";
export { ForwardRef as ReactComponent };